
import { defineComponent, ref, onMounted, computed } from "vue";
import { scores } from "@/store/scores";
import { ISOtoDateGB } from "@/helpers/index";

import { comments, getComments } from "@/store/comments/index";

export default defineComponent({
  name: "Leaderboard",
  components: {},
  props: {
    pageSize: {
      type: Number,
      default: 10,
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    onMounted(async () => {
      getComments();
    });

    const currentSort = ref<string>("score");
    const currentSortDir = ref<string>("desc");
    const currentPage = ref<number>(1);

    // const formatDate = (date: any) => {
    //   const d = new Date(date);

    //   return d.toLocaleDateString("en-GB");
    //   // console.log(date);
    //   // return new Date(date);
    // };

    const nextPage = () => {
      if (currentPage.value * props.pageSize < asArray.value.length) {
        currentPage.value++;
      }
    };
    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const isANextPage = computed((): boolean => {
      return currentPage.value * props.pageSize < asArray.value.length;
    });

    const asArray = computed(() => {
      return Object.values(comments.value).filter(() => {
        return true;
      });
    });

    const sortedScores = computed(() => {
      const array = asArray.value;

      return (
        array
          // .sort((a: any, b: any) => {
          //   let modifier = 1;
          //   if (currentSortDir.value === "desc") {
          //     modifier = -1;
          //   }

          //   if (a[currentSort.value] < b[currentSort.value]) {
          //     return -1 * modifier;
          //   }
          //   if (a[currentSort.value] > b[currentSort.value]) {
          //     return 1 * modifier;
          //   }
          //   return 0;
          // })
          .sort(function(a, b) {
            //console.log(new Date(b.date).getTime());
            return new Date(b.date).getTime() - new Date(a.date).getTime();
          })
          .filter((row: any, index: number) => {
            const start = (currentPage.value - 1) * props.pageSize;
            const end = currentPage.value * props.pageSize;
            if (index >= start && index < end) {
              return true;
            }
          })
      );
    });

    return {
      nextPage,
      prevPage,
      currentSort,
      currentSortDir,
      sortedScores,
      currentPage,
      asArray,
      isANextPage,
      comments,
      ISOtoDateGB,
    };
  },
});
